import * as Yup from 'yup';

export const schema = Yup.object().shape({
  code: Yup.string().required(),
  name: Yup.string().required(),
  lat: Yup.number().required(),
  lon: Yup.number().required(),
  address: Yup.string().required(),
  active: Yup.boolean().required(),
  mall_id: Yup.string().required()
});

export const formInitialState = {
  code: '',
  name: '',
  lat: '',
  lon: '',
  address: '',
  active: false,
  mall_id: ''
};

export const formErrorInitialState = {
  codeError: false,
  nameError: false,
  latError: false,
  lonError: false,
  addressError: false,
  activeError: false,
  mall_idError: false
};
